import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "instruments";

@Injectable({
  providedIn: "root",
})
export class InstrumentationHandlerService {
  constructor(private APIService: ApiService) {}

  getInstruments() {
    return this.APIService.get(`${PATH}`);
  }
}
